import React from 'react';
import { PeopleAlt, Receipt, NewReleasesSharp, EventSeat, PermMedia } from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';

export const sidebarNavs = [
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'section',
    children: [
      {
        name: <IntlMessages id={'pages.usersPage'} />,
        type: 'item',
        icon: <PeopleAlt />,
        link: '/users',
      },
      {
        name: <IntlMessages id={'pages.testsPage'} />,
        type: 'item',
        icon: <Receipt />,
        link: '/tests',
      },
      {
        name: <IntlMessages id={'pages.newsPage'} />,
        type: 'item',
        icon: <NewReleasesSharp />,
        link: '/news',
      },
      {
        name: <IntlMessages id={'pages.eventsPage'} />,
        type: 'item',
        icon: <EventSeat />,
        link: '/events',
      },
      {
        name: <IntlMessages id={'pages.mediaPage'} />,
        type: 'item',
        icon: <PermMedia />,
        link: '/media',
      },
    ],
  },
];

export const horizontalDefaultNavs = [
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'collapse',
    children: [
      {
        name: <IntlMessages id={'pages.testsPage'} />,
        type: 'item',
        icon: <PeopleAlt />,
        link: '/users',
      },
      {
        name: <IntlMessages id={'pages.testsPage'} />,
        type: 'item',
        icon: <Receipt />,
        link: '/tests',
      },
      {
        name: <IntlMessages id={'pages.newsPage'} />,
        type: 'item',
        icon: <NewReleasesSharp />,
        link: '/news',
      },
      {
        name: <IntlMessages id={'pages.eventsPage'} />,
        type: 'item',
        icon: <EventSeat />,
        link: '/events',
      },
      {
        name: <IntlMessages id={'pages.mediaPage'} />,
        type: 'item',
        icon: <PermMedia />,
        link: '/media',
      },
    ],
  },
];

export const minimalHorizontalMenus = [
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'collapse',
    children: [
      {
        name: <IntlMessages id={'pages.usersPage'} />,
        type: 'item',
        icon: <PeopleAlt />,
        link: '/users',
      },
      {
        name: <IntlMessages id={'pages.testsPage'} />,
        type: 'item',
        icon: <Receipt />,
        link: '/users',
      },
      {
        name: <IntlMessages id={'pages.newsPage'} />,
        type: 'item',
        icon: <NewReleasesSharp />,
        link: '/news',
      },
      {
        name: <IntlMessages id={'pages.eventsPage'} />,
        type: 'item',
        icon: <EventSeat />,
        link: '/events',
      },
      {
        name: <IntlMessages id={'pages.mediaPage'} />,
        type: 'item',
        icon: <PermMedia />,
        link: '/media',
      },
    ],
  },
];
